import { ViewerAnalytics } from './ViewerAnalytics';

const instance = new ViewerAnalytics();
export { instance as analytics };

export * from './getLoadModelData';


export * from './queryWebGPUPayloads';
import { queryWebGPUAdapterPayload, queryWebGPUDeviceLostPayload } from './queryWebGPUPayloads';

export function trackWebGPUDeviceCreated() {
  const payload = queryWebGPUAdapterPayload(true);
  instance.track('viewer.webgpu.device.created', payload);
}

export function trackWebGPUDeviceLost(message, gpuMemoryStats) {
  const payload = queryWebGPUDeviceLostPayload(message, gpuMemoryStats);
  instance.track('viewer.webgpu.device.lost', payload);
}